import { APIError } from '@/lib/api/api';
import { useAuth } from '@/lib/auth/auth';
import { useMutation } from '@tanstack/react-query';

export function useEmailVerificationResend() {
  const request = useAuth((state) => state.request);
  const setEmailVerified = useAuth((state) => state.setEmailVerified);

  return useMutation({
    mutationFn: async () => {
      try {
        return await request('/auth/email/resend', { method: 'POST' });
      } catch (error) {
        if (error instanceof APIError && /already verified/i.test(error.message)) {
          setEmailVerified(true);
        }
        throw error;
      }
    },
  });
}
